<script>

    /**
     *
     */
    export default {


        props: {
            id: {
                type: Number,
                required: true,
            },
            src: {
                type: String,
                default: '',
                required: true,
            },
            captions: {
                type: String,
                default: '',
            },
            width: {
                type: Number,
                required: true,
            },
            height: {
                type: Number,
                required: true,
            },
            smallSrc: {
                type: String,
                default: null,
            },
            smallWidth: {
                type: Number,
                default: 0,
            },
            smallHeight: {
                type: Number,
                default: 0,
            },
            isVisible: {
                type: Boolean,
                default: true,
            },
            thumbnailSrc: {
                type: String,
                default: null,
            },
        },

        computed: {
            classes() {
                return {
                    photoswipeItem: true,
                    [`photoswipeItem-is${this.id}`]: true,
                };
            },
        },

        methods: {
            itemSelected() {
                this.$parent.openPhotoswipe(this);
            },


            getPhotoswipeItemConfig() {
                return {
                    normal: {
                        src: this.src,
                        w: this.width,
                        h: this.height,
                    },
                    mobile: {
                        src: this.smallSrc,
                        w: this.smallWidth,
                        h: this.smallHeight,
                    },
                    msrc: this.thumbnailSrc,
                    captions: this.captions,
                };
            },


            hasId(imageId) {
                return this.id === imageId;
            },
        },
    };
</script>

<template>
    <div :class="classes" @click="itemSelected" v-show="isVisible">
        <slot />
    </div>
</template>
